import { useEffect } from "react";
import { isFontPreference, useFont } from "@/shared/lib/hooks/useFont";
import { usePreferences } from "../hooks/usePreferences";

/**
 * Reconciles the account-synced font into the local store after auth.
 * Local mirror paints first (boot IIFE, zero FOUC); the server value is the
 * cross-device source of truth once it arrives. Renders nothing.
 *
 * No loop with the Settings mutation: `useUpdatePreferences` cache-writes the
 * full returned object on success, so the effect sees an equal value and
 * no-ops in the steady state.
 */
export function FontPreferenceSync() {
  const { data } = usePreferences();
  const { font, setFont } = useFont();

  useEffect(() => {
    if (data && isFontPreference(data.font) && data.font !== font) {
      setFont(data.font);
    }
    // Server value is the only trigger we care about — re-running on local
    // `font` changes would fight in-flight updates.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.font]);

  return null;
}
